import { Grid, styled } from '@mui/material';

export const StyledApplicationAccountDetails = styled(Grid)(() => ({
	maxHeight: 'auto',
	width: '100%',
	display: 'flex',
}));
